// extracted by mini-css-extract-plugin
export default {"selected":"MemoriaNombres_selected__Zw2Zg","inputBox":"MemoriaNombres_inputBox__8IEjI","inputsOptions":"MemoriaNombres_inputsOptions__aCJAy"};